// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"53":"webfontloader","389":"404","792":"main"}[chunkId] + "." + {"53":"8b405cb3","389":"da479588","792":"c9feac6a"}[chunkId] + ".js";
};